// extracted by mini-css-extract-plugin
export default {"customButton":"style_customButton__GpVR+","inactive":"style_inactive__DeY2D","outline":"style_outline__IEbX6"};